export default function InertiaExample({ name }: { name: string }) {
  return (
    <>
      {' '}
      <div>Project Short main page</div>
    </>
  );
}
